export default __webpack_public_path__ + "static/media/medium.a70e90d1.svg";